import create from 'zustand';

export const useObserveStore = create(set => ({
  observations: {}
}));
